<template>
  <div class="col-md-12 mx-auto">
    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow v-if="currentSectionId" :bilan-type="bilanType"
                  :params="{operationId: operationId, currentSection:currentSectionId}"
                  :title="operationName" route-back="OperationShow"/>
      <back-arrow v-else :bilan-type="bilanType" :title="operationName"/>
      <b-link class="main-color-text  bold-text mr-3" v-on:click="exportPdf()">
        {{ $t('operation.bilan.exporter') }}
        <file-download-icon size="18"/>
      </b-link>
    </div>

    <div>
      <b-table
        id="tableLots"
        ref="tableLots"
        v-disable-scroll="true"
        :fields="fields"
        :items="items"
        bordered
        class="sticky-table"
        responsive
        striped
        thead-class="background-main-color">

        <!-- vendu-->
        <template #cell(vendu)="data">
          <check-icon v-if="data.item.vendu.value" color="white" size="24"/>
        </template>

        <!-- Numero du lot -->
        <template #cell(lotNumber)="data">
          <span class="d-flex align-items-center justify-content-center row-height"> {{ data.item.lotNumber }}</span>
        </template>

        <!-- Nom du lot -->
        <template #cell(type)="data">
          <span> {{ data.item.type }}</span>
        </template>

        <!-- Surface ou vendeur du lot -->
        <template #cell(surface)="data">
          <span class="d-flex justify-content-center"> {{ data.item.surface }} m²</span>
        </template>

        <!-- Prix de vente du lot -->
        <template #cell(prix)="data">
          <b-link class="light-blue-color" @click="goToEditLots(data)">
            {{ convertToEuros(data.item.prix) }}
          </b-link>
        </template>

        <!-- Prix au m2 du lot -->
        <template #cell(prixParM2)="data">
          <b-link class="light-blue-color" @click="goToEditLots(data)">
            {{ convertToEuros(data.item.prixParM2) }}
          </b-link>
        </template>

        <template #cell(prixParM2FAI)="data">
          {{ convertToEuros(data.item.prixParM2FAI) }}
        </template>

        <!-- Agent immobilier ou vendeur du lot -->
        <template #cell(agent)="data">
          <div v-if="!data.item.agent.edit" @click="enableEdit(data.item.lotNumber, 'agent')">
            {{ data.item.agent.value }} &nbsp;
          </div>
          <div v-else
               @change="saveCommercialisationValue(data.item.lotNumber, 'agent'); disableEdit(data.item.lotNumber, 'agent');">
            <b-form-input
              :id="`agent[${data.item.lotNumber}]`"
              v-model="data.item.agent.value "
              autofocus
              maxlength="250"
              type="text">
            </b-form-input>
          </div>
        </template>

        <!-- Statut Brut/Rénové du lot -->
        <template #cell(statut)="data">
          <b-form-select
            id="statut-input"
            v-model="data.item.statut.value.value"
            :style="{borderColor: '#009DFF', backgroundColor: '#DCECF7', width:'auto'}"
            class="bold-text main-color-text"
            size="sm"
            @change="saveCommercialisationValue(data.item.lotNumber, 'statut')">
            <option v-for="status in statusLots" :value="status.value">
              {{ $t(status.text) }}
            </option>
          </b-form-select>
        </template>

        <!-- Commission agence TTC à la vente  -->
        <template #cell(commissionTTC)="data">
          <div v-if="!data.item.commissionTTC.edit" @click="enableEdit(data.item.lotNumber, 'commissionTTC')">
            {{ displayInEuros(data.item.commissionTTC.value) }} &nbsp;
          </div>
          <div v-else
               v-on:focusout="saveCommercialisationValue(data.item.lotNumber, 'commissionTTC');
               disableEdit(data.item.lotNumber, 'commissionTTC');">
            <b-form-input
              :id="`commissionTTC[${data.item.lotNumber}]`"
              v-model="data.item.commissionTTC.value"
              autofocus
              step="any"
              type="number">
            </b-form-input>
          </div>
        </template>



        <!-- Acheteur et coordonnées -->
        <template #cell(acheteur)="data">
          <div v-if="!data.item.acheteur.edit" @click="enableEdit(data.item.lotNumber, 'acheteur')">
            {{ data.item.acheteur.value }} &nbsp;
          </div>
          <div v-else
               @change="saveCommercialisationValue(data.item.lotNumber, 'acheteur'); disableEdit(data.item.lotNumber, 'acheteur');">
            <b-form-input
              :id="`agent[${data.item.lotNumber}]`"
              v-model="data.item.acheteur.value"
              autofocus
              maxlength="250"
              type="text">
            </b-form-input>
          </div>
        </template>

        <!-- Date du SSP -->
        <template #cell(ssp)="data">
          <div v-if="data.item.ssp === null">
            &nbsp;
          </div>
          <b-link v-else class="light-blue-color" @click="goToEditLots(data)">
            {{ new Date(data.item.ssp).toLocaleDateString() }}
          </b-link>
        </template>

        <!-- Date de l'acte -->

        <template #cell(acte)="data">
          <div v-if="data.item.acte === null">
            &nbsp;
          </div>
          <b-link v-else class="light-blue-color" @click="goToEditLots(data)">
            {{ new Date(data.item.acte).toLocaleDateString() }}
          </b-link>
        </template>

        <!-- Statut du prêt bancaire -->
        <template #cell(pret)="data">
          <b-form-select
            id="pret-input"
            v-model="data.item.pret.value.value"
            :style="{borderColor: '#009DFF', backgroundColor: '#DCECF7', width:'auto'}"
            class="bold-text main-color-text"
            size="sm"
            @change="saveCommercialisationValue(data.item.lotNumber, 'pret')">
            <option v-for="status in demandeStatus" :value="status.value">
              {{ $t(status.text) }}
            </option>
          </b-form-select>
        </template>

        <!-- Statut du permis de construire -->
        <template #cell(pc)="data">
          <b-form-select
            id="pc-input"
            v-model="data.item.pc.value.value"
            :style="{borderColor: '#009DFF', backgroundColor: '#DCECF7', width:'auto'}"
            class="bold-text main-color-text"
            size="sm"
            @change="saveCommercialisationValue(data.item.lotNumber, 'pc')">
            <option v-for="status in demandeStatus" :value="status.value">
              {{ $t(status.text) }}
            </option>
          </b-form-select>
        </template>

        <!-- Situation fiscale du lot -->
        <template #cell(fiscalite)="data">
          <b-form-select
            id="fiscalite-input"
            v-model="data.item.fiscalite.value.value"
            :style="{borderColor: '#009DFF', backgroundColor: '#DCECF7', width:'auto'}"
            class="bold-text main-color-text"
            size="sm"
            @change="saveCommercialisationValue(data.item.lotNumber, 'fiscalite')">
            <option v-for="status in fiscaliteTypes" :value="status.value">
              {{ $t(status.text) }}
            </option>
          </b-form-select>
        </template>

        <!-- Commentaire associé à la commercialisation du lot -->
        <template #cell(commentaire)="data">
          <div v-if="!data.item.commentaire.edit" @click="enableEdit(data.item.lotNumber, 'commentaire')">
            {{ data.item.commentaire.value }} &nbsp;
          </div>
          <div v-else
               @change="saveCommercialisationValue(data.item.lotNumber, 'commentaire'); disableEdit(data.item.lotNumber, 'commentaire');">
            <b-form-input
              :id="`commentaire[${data.item.lotNumber}]`"
              v-model="data.item.commentaire.value "
              autofocus
              maxlength="250"
              type="text">
            </b-form-input>
          </div>
        </template>

        <!-- Etage -->
        <template #cell(etage)="data">
          <b-form-select
            id="etage-input"
            v-model="data.item.etage.value"
            :style="{borderColor: '#009DFF', backgroundColor: '#DCECF7', width:'auto'}"
            class="bold-text main-color-text"
            size="sm"
            @change="saveCommercialisationValue(data.item.lotNumber, 'etage' )">
            <option v-for="etage in etagesTypes" :value="etage.value">
              {{ $t(etage.text) }}
            </option>
          </b-form-select>
        </template>


        <!-- Lot- co-pro -->
        <template #cell(lotCoPro)="data">
          <div v-if="!data.item.lotCoPro.edit && data.item.lotCoPro.value !== '' " @click="enableEdit(data.item.lotNumber, 'lotCoPro')">
            {{ data.item.lotCoPro.value }}
          </div>
          <div v-else
               @change="saveCommercialisationValue(data.item.lotNumber, 'lotCoPro'); disableEdit(data.item.lotNumber, 'lotCoPro');">
            <b-form-input
              :id="`agent[${data.item.lotNumber}]`"
              v-model="data.item.lotCoPro.value"
              autofocus
              maxlength="250"
              type="text">
            </b-form-input>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

import Vue from "vue";
import BackArrow from "../../components/b122/BackArrow.vue";
import api from "../../services/api";

export default {
  name: "CommercialisationLotsShow",
  components: {
    BackArrow
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      currentSectionId: this.$route.params.currentSectionId,
      operationName: null,
      statusLots: [],
      demandeStatus: [],
      fiscaliteTypes: [],
      operationLots : [],
      etagesTypes:[],

      bilanType: null,
      fields: [
        {
          label: 'Vendu',
          key: 'vendu',
          thStyle: {minWidth: '3.5vw'},
          class: 'sticky-col-0',
          tdClass: ['no-wrap', 'align-middle', 'background-main-color-hover', 'bold-text', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text'],
        },
        {
          label: 'Lot',
          key: 'lotNumber',
          thStyle: {minWidth: '2vw'},
          class: 'sticky-col-1',
          tdClass: ['no-wrap', 'align-middle', 'background-main-color-hover', 'bold-text', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text'],
        },
        {
          label: 'Nom',
          key: 'type',
          thStyle: {minWidth: '2vw'},
          class: 'sticky-col-2',
          tdClass: ['no-wrap', 'align-middle', 'background-main-color-hover', 'bold-text', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: 'Surface',
          key: 'surface',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'bold-text', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Lot co-pro",
          key: 'lotCoPro',
          thStyle: {minWidth: '2.5vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Étage",
          key: 'etage',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Annexes",
          key: 'commentaire',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: 'Prix net vendeur',
          key: 'prix',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: 'Prix par m² net vendeur',
          key: 'prixParM2',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: 'Prix par m² net vendeur FAI',
          key: 'prixParM2FAI',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: 'Brut/Rénové',
          key: 'statut',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: 'Commission agence TTC',
          key: 'commissionTTC',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Acquéreurs",
          key: 'acheteur',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Date SSP",
          key: 'ssp',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Date de l'acte",
          key: 'acte',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Prêt bancaire acquéreur",
          key: 'pret',
          thStyle: {minWidth: '6vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Situation PC acquéreur",
          key: 'pc',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        },
        {
          label: "Fiscalité",
          key: 'fiscalite',
          thStyle: {minWidth: '2vw'},
          tdClass: ['align-middle', 'text-center'],
          thClass: ['align-middle', 'text-center', 'bold-text']
        }
      ],
      items: []
    }
  },

  mounted() {
    this.fetchData()
  },



  methods: {

    async fetchData() {
      await this.fetchOperation()
      await this.fetchCommercialisationLots()
      await this.getStatusLots()
      await this.getDemandeStatus()
      await this.getFiscaliteType()
      await this.getEtages()
    },

    async saveCommercialisationValue(lotNumber, field) {

      this.items.forEach(lot => {
        if (lot['lotNumber'] === lotNumber) {
          let data = new FormData()
            if (lot[field].value instanceof Object) {
              if (lot[field].value.value == null) {
                return false
              }
              data.append(field, lot[field].value.value)
            } else {
              if (lot[field].value == null) {
                return false
              }
              data.append(field, lot[field].value)
            }


          let url = 'commercialisation'
          if (lot.id) {
            url = '/commercialisation/' + lot.id
          }
          api({
            method: 'POST',
            url: url,
            data: data
          })
            .then(() => {
              this.fetchCommercialisationLots()
            })
            .catch((error) => {
              if (error.response.status === 401 || error.response.status === 404) {
                this.$router.push({
                  name: 'CommercialisationLotsShow',
                  params: {
                    operationId: this.operationId,
                    message: error.response.data.message
                  }
                })
              }
            })
        }
      })
    },


    async getEtages() {
      await api
        .get(`/operationLot/getEtages`)
        .then(response => {
          this.etagesTypes = response.data
        })

    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationName = response.data.name
          this.bilanType = response.data.bilanType
        })
    },

    async fetchCommercialisationLots() {
      await api
        .get(`/commercialisation/getAllCommercialisationForOperation/${this.operationId}`)
        .then(response => {
          this.items = response.data
        })
    },

    async getStatusLots() {
      await api.get(`/commercialisation/getStatusLots`)
        .then(response => {
          this.statusLots = response.data.sort((a, b) => {
            const textA = this.$t(a.text).toLowerCase();
            const textB = this.$t(b.text).toLowerCase();
            return textA.localeCompare(textB);
          });
        });
    },

    async getDemandeStatus() {
      await api.get(`/commercialisation/getDemandeStatus`)
        .then(response => {
          this.demandeStatus = response.data.sort((a, b) => {
            const textA = this.$t(a.text).toLowerCase();
            const textB = this.$t(b.text).toLowerCase();
            return textA.localeCompare(textB);
          });
        });
    },


    async getFiscaliteType() {
      await api.get(`/commercialisation/getFiscaliteType`)
        .then(response => {
          this.fiscaliteTypes = response.data.sort((a, b) => {
            const textA = this.$t(a.text).toLowerCase();
            const textB = this.$t(b.text).toLowerCase();
            return textA.localeCompare(textB);
          });
        });
    },

    convertToEuros(value) {
      let euros = (value / 100).toFixed(2);
      return Intl.NumberFormat().format(euros) + " €"
    },

    displayInEuros(value) {
      if (value != null) {
        return Intl.NumberFormat().format(value) + " €"
      } else {
        return null
      }
    },

    enableEdit(lotNumber, field) {
      this.disableAllEdit()
      this.items.forEach(lot => {
        if (lot['lotNumber'] === lotNumber) {
          lot[field]['edit'] = true
        }
      })
    },

    disableEdit(lotNumber, field) {
      this.items.forEach(lot => {
        if (lot['lotNumber'] === lotNumber) {
          lot[field]['edit'] = false
        }
      })
    },

    disableAllEdit() {
      this.items.forEach(lot => {
        for (const property in lot) {
          if (lot[property] instanceof Object && lot[property].hasOwnProperty('edit')) {
            lot[property]['edit'] = false
          }
        }
      })
    },

    goToEditLots(data) {
      const lotId = data && data.item && data.item.lotId ? data.item.lotId : null
      this.$router.push({
        name: 'OperationLotsEdit',
        params: {
          operationId: this.operationId,
          fromCommercialisation: true,
          currentSectionId: this.currentSectionId,
          redirectToLotId: lotId,
        }
      })
    },

    goToEditPlanning() {
      this.$router.push({
        name: 'OperationEvenementCreateEdit',
        params: {
          operationId: this.operationId,
          fromCommercialisation: true,
          currentSectionId: this.currentSectionId
        }
      })
    },


    exportPdf() {
      // this.loadingPdf = true

      api.post(`/commercialisation/downloadCommercialisationPdf/${this.operationId}`, {}, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Commercialisation-${this.operationName}-${new Date().toLocaleDateString('fr-FR')}.pdf`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        // this.loadingPdf = false
      }).catch(() => {
        // this.loadingPdf = false
      })
    },
  }
}
</script>



<style>

.table-input{
  min-width: 250px;
  font-size: 14px;
  border: none;
  background-color: white;
  color: var(--main-color);
  text-align: left;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--main-color);
  border-color: var(--main-color);
  color: var(--main-white);
}

.table.b-table > thead > tr > .table-b-table-default {
  background-color: var(--main-color);
  color: var(--main-white);
}

.row-height {
  min-height: 4vh;
}

.sticky-col-0 {
  position: sticky;
  left: 0;
  background-color: var(--main-color-hover);
  border: var(--main-white) solid 1px;
  color: var(--main-white);
  z-index: 10;
}

.sticky-col-1 {
  position: sticky;
  left: 3.5vw;
  background-color: var(--main-color-hover);
  border: var(--main-white) solid 1px;
  color: var(--main-white);
  z-index: 10;
}

.sticky-col-2 {
  position: sticky;
  left: 5.5vw;
  background-color: var(--main-color-hover);
  border: var(--main-white) solid 1px;
  color: var(--main-white);
  z-index: 12;
}

.no-wrap {
  white-space: nowrap;
}

#tableLots th, #tableLots td {
  padding: 0.35rem !important;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/views/commercialisation/CommercialisationLotsShow.vue